import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Site } from '../../models/misc.model';

@Component({
  selector: 'app-site-icon-and-name',
  templateUrl: './site-icon-and-name.component.html',
  styleUrls: ['./site-icon-and-name.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SiteIconAndNameComponent {
  @Input() tooltipLabel!: string;
  // The old version icons
  @Input() set site(site: Site) {
    if (site) {
      this.cssClass = `bg-grey-${site.type}`;
      this.siteName = site.name;
    } else {
      this.cssClass = '';
      this.siteName = '';
    }
  }

  cssClass: string;
  siteName: string;

  // The new version icons
  @Input() set item(item: any) {
    if (item) {
      const { isGroup, type, typeName } = item;

      this.isGroup = isGroup;
      this.type = type;
      this.typeName = typeName;
    }
  }
  isGroup: boolean;
  type: number;
  typeName: string;
}
